import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "locale"

  connect() {
    super.connect()
    this.sendCurrentLocale()
    this.observeLocaleChanges()
  }

  disconnect() {
    super.disconnect()
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  sendCurrentLocale() {
    const locale = document.documentElement.lang
    if (locale) {
      this.send("connect", { locale })
    }
  }

  observeLocaleChanges() {
    this.observer = new MutationObserver(() => {
      this.sendCurrentLocale()
    })

    this.observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["lang"]
    })
  }
}
